/** @format */

import { saveAs } from "file-saver";
import { DasboardDto } from "../../models";

function escCell(v: string | number) {
  return `"${String(v).replace(/"/g, '""')}"`;
}

export function exportDashboardSnapshotCsv(data: DasboardDto, year: number) {
  const lines: string[] = [];
  lines.push(["Metric", "Value"].map(escCell).join(","));
  lines.push([escCell("Intake year"), escCell(year)].join(","));
  lines.push([escCell("All applications"), escCell(data.allApplications)].join(","));
  lines.push([escCell("Incomplete"), escCell(data.totalInCompleted)].join(","));
  lines.push([escCell("Assessed"), escCell(data.totalAssessed)].join(","));
  lines.push(
    [escCell("Returning applicants"), escCell(data.returningApplicants)].join(",")
  );
  lines.push([escCell("Female"), escCell(data.femaleApplicants)].join(","));
  lines.push([escCell("Male"), escCell(data.maleApplicants)].join(","));
  lines.push("");
  lines.push(["Stage", "Count"].map(escCell).join(","));
  (data.status ?? []).forEach((s) => {
    lines.push([escCell(s.name), escCell(s.value)].join(","));
  });
  lines.push("");
  lines.push(["Race", "Count"].map(escCell).join(","));
  (data.race ?? []).forEach((s) => {
    lines.push([escCell(s.name), escCell(s.value)].join(","));
  });
  lines.push("");
  lines.push(["Institution", "Count"].map(escCell).join(","));
  (data.universities ?? []).forEach((s) => {
    lines.push([escCell(s.name), escCell(s.value)].join(","));
  });

  const blob = new Blob([lines.join("\n")], {
    type: "text/csv;charset=utf-8;",
  });
  saveAs(blob, `thuthuka-dashboard-${year}.csv`);
}
